import request from '@/libs/request';
import config from '@/config';
const baseUrl = config.api_base;

/**
 * 获取所有分组
 * @param {*} params
 * @returns
 */
export const ConfigGroupList = params => {
  return request('get', `${baseUrl}/api/auth/sys/dict/group/all`, params);
};

/**
 * 批量删除分组
 */
export const ConfigGroupDeleteBatch = data => {
  return request('post', `${baseUrl}/api/auth/sys/dict/group/delete/batch`, data);
};

/**
 * 深度批量删除分组{apiNoUse}
 */
export const ConfigGroupDeleteBatchDeep = data => {
  return request('post', `${baseUrl}/api/auth/sys/dict/group/delete/batch/deep`, data);
};

/**
 * 删除分组
 */
export const ConfigGroupDelete = data => {
  return request('post', `${baseUrl}/api/auth/sys/dict/group/delete/one`, data);
};

/**
 * 深度删除分组{apiNoUse}
 */
export const ConfigGroupDeleteDeep = data => {
  return request('post', `${baseUrl}/api/auth/sys/dict/group/delete/one/deep`, data);
};

/**
 * 编辑分组
 */
export const ConfigGroupEdit = data => {
  return request('post', `${baseUrl}/api/auth/sys/dict/group/edit`, data);
};

/**
 * 新增分组
 */
export const ConfigGroupSave = data => {
  return request('post', `${baseUrl}/api/auth/sys/dict/group/save`, data);
};

/**
 * 配置项列表
 * @param {*} params
 * @returns
 */
export const ConfigGroupItemList = params => {
  return request('get', `${baseUrl}/api/auth/sys/dict/item/list`, params);
};

/**
 * 删除数据类型
 */
export const ConfigItemDelete = data => {
  return request('post', `${baseUrl}/api/auth/sys/dict/item/del`, data);
};

/**
 * 批量删除数据类型
 */
export const ConfigItemBatchDelete = data => {
  return request('post', `${baseUrl}/api/auth/sys/dict/item/del/batch`, data);
};

/**
 * 编辑数据类型
 */
export const ConfigItemEdit = data => {
  return request('post', `${baseUrl}/api/auth/sys/dict/item/edit`, data);
};

/**
 * 新增数据类型
 */
export const ConfigItemSave = data => {
  return request('post', `${baseUrl}/api/auth/sys/dict/item/save`, data);
};
